import React, { useContext, createRef, useState, FunctionComponent, MutableRefObject, RefObject, useEffect, useRef } from 'react';
import iro from '@jaames/iro';
import { Context } from "../../../../Context/context";
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles((theme) => ({
  colorPickerContainer: {
    display: "flex"
  }
}))

interface IroColorPicker {
  on: (action: string, callback: Function) => void;
  color: {
    hexString: string;
    rgbString: string
    set: (value: any) => void;
    setState: (state: any) => void;
  }
}

interface IroColor {
  rgbString: string,
  hexString: string
}

export interface ColorPickerProps {
  className?: string;
  value?: string;
  onColorSet?: (color: string) => void;
}


const getColor = ( rgbString: string ) => {
  let color = new iro.Color( rgbString )
  color.setChannel('hsv', 'v', 100);
  return color

}

const ColorPicker = ({className, onColorSet = () => {}}: ColorPickerProps) => {

  const {
    state: { brushColor },
  } = useContext(Context);
  const [ currentColor, setColor ] = useState( brushColor[0] )
  let colorPicker: MutableRefObject<IroColorPicker | null> = useRef<IroColorPicker | null>(null);
  let el: RefObject<HTMLDivElement> = createRef<HTMLDivElement>();

  useEffect(() => {
    if (!el.current) {
      return;
    }
    if (!colorPicker.current) {
      // create a new iro color picker and pass component props to it
      // @ts-ignore
      colorPicker.current = new iro.ColorPicker(el.current, 
          { color: getColor( currentColor ),
            layout: [
            { 
              component: iro.ui.Wheel,
            }]}); 
      // call onColorChange prop whenever the color changes
      if (!colorPicker?.current) {
        return;
      }
      colorPicker.current.on('color:change', (color: IroColor ) => {
        colorPicker?.current?.color.set( color.hexString );
        onColorSet?.call( this, color.hexString );
      });
    }
  });
  return  <>
            <div className={className} ref={el} id="colorPickerV2" />
          </>;
};

export default ColorPicker;
